<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <canvas
      id="comparativoTime"
      width="150"
      height="70"
    />
    <div
      v-if="exibirLegenda"
      id="legendaVendas"
      class="text-center px-3"
    >
      <v-row
        align="center"
        class="ma-0"
      >
        <v-avatar
          class="mr-1"
          color="#ed934f"
          size="10"
        />
        <span class="mr-3 font-weight-light">Variação Anual de Faturamento</span>
        <v-avatar
          class="mr-1"
          color="#cadaed"
          size="10"
        />
        <span class="mr-3 font-weight-light">Faturamento Ano Anterior</span>
        <v-avatar
          class="mr-1"
          color="#4780b8"
          size="10"
        />
        <span class="mr-3 font-weight-light">Faturamento Corrente</span>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Time from '../../../../services/time'
  // import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashoboardTicketSupervisorEmpresa',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      vendedores: [],
      vendedoresSelect: [],
      areas: [],
      redes: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      legendaEmpresa: [],
      text: null,
      montarGrafico: true,
      loading: false,
      error: null,
      exibirLegenda: false,
      chartBarLinha: {},
    }),

    created () {
      eventEmit.$on('update-comparativo-faturamento', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-comparativo-faturamento', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select, supervisor, vendedor, areas, redes, receita, segmento, categoria, promotor, classificacao, vendedores) {
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.vendedores = vendedor
        this.areas = areas
        this.redes = redes
        this.vendedoresSelect = vendedores

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.exibirLegenda = false

        if (this.chartBarLinha.data) {
          this.chartBarLinha.destroy()
        }

        await Time.showComparativoFaturamentoMesesAnteriores(this.select, this.supervisor, this.vendedores, this.areas, this.redes, this.receita, localStorage.tokencontrato, this.segmento, this.vendedoresSelect).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('comparativoTime').getContext('2d')

            this.chartBarLinha = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.datasFaturamento,
                datasets: [
                  {
                    label: 'FaturamentoAnoAnterior',
                    data: resposta.data.faturamentoAnoAnterior,
                    backgroundColor: '#cadaed',
                    order: 2,
                  },
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamentoCorrente,
                    backgroundColor: '#4780b8',
                    order: 3,
                  },
                  {
                    label: 'Porcentagem',
                    data: resposta.data.valoresExibicao,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 2) {
                        return resposta.data.porcentagem[tooltipItem.index].toFixed(2).toLocaleString('pt-BR') + '%'
                      } else if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        var ano = parseFloat(tooltipItem[0].xLabel.slice(-2)) - 1
                        var mes = tooltipItem[0].xLabel.slice(0, -2)

                        tooltipItem[0].xLabel = mes + ano

                        return tooltipItem[0].xLabel
                      } else if (tooltipItem[0].datasetIndex === 2) {
                        tooltipItem[0].xLabel = 'Variação'

                        return tooltipItem[0].xLabel
                      } else {
                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento lançado para comparação nos ultimos 7 meses') {
            this.text = resposta.data.msg

            if (this.chartBarLinha.data) {
              this.chartBarLinha.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #legendaSupervisorEmpresa
    margin: 1rem 0 0 5rem

</style>

<style scoped>
 .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #comparativoTime {
      margin: -1rem 0 3rem 1rem;
      width: 330px !important;
      height: 260px !important;
    }

    #legendaVendas {
      font-size: 10px;
      margin: 1rem 0 1rem 2rem
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #comparativoTime {
      margin: -1rem 0 0 0;
      width: 800px !important;
      height: 500px !important;
    }

    #legendaVendas {
      font-size: 14px;
      margin: 1rem 0 2rem 10rem
    }
  }
</style>
